 export enum NatureTransfertEnum {
Default = 0,
Rubrique = 1,
Tableau = 2,
Scenario = 3,
Libelle = 4,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/NatureTransfertEnum.ts